"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isWebpSupported() {
    return document.body.classList.contains('webp');
}
exports.default = isWebpSupported;
